import { ChangeDetectionStrategy, Component, ElementRef, input } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';

@Component({
  selector: 'rt-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.spinner-color]': 'spinnerColor()',
    '[class]': 'variant()',
  },
  standalone: true,
})
export class SpinnerComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'small', 'small-x', 'small-xx'],
  ];
  public readonly variant = input(...ComponentVariantTransform(SpinnerComponent.VARIANTS));
  public readonly spinnerColor = input<boolean>(false);
  public readonly animate = input<boolean>(true);

  constructor(public elRef: ElementRef) {}
}
